import "./Capabilities.css";
import Footer from "./Footer";
import manufacturingImage from "../assets/manufacturing-main.png";

export default function CapManufacture() {
  return (
    <section id="cap-man">
      <section>

        {/* TOP SECTION */}
        <div className="capability-wrapper-a">
          <div className="capability-text-a">

            <h3>Manufacturing</h3>

            <h3>
              Integrated, lean value streams from casting to machining under one roof.
            </h3>

            <p>
              At SCL, manufacturing is organised as value streams that link
              casting, heat treatment and machining into a continuous flow.
              Having the complete process chain in a single campus allows rapid
              quality feedback, faster problem-solving and shorter lead times
              for our customers.
            </p>

          </div>
        </div>

        {/* MANUFACTURING IMAGE */}
        <div className="manufacturing-main-image">
          <img
            src={manufacturingImage}
            alt="SCL Manufacturing"
          />
        </div>

        {/* CASTING SECTION */}
        <h2 className="capability-title">
          Versatile Casting Excellence – GDC & PDC
        </h2>

        <div className="cap-underline"></div>

        <p
          style={{
            textAlign: "center",
            margin: "30px 220px",
          }}
        >
          SCL delivers high-integrity aluminium castings through both
          Gravity Die Casting (GDC) and High-Pressure Die Casting (HPDC),
          supported by advanced automation and robust process control.
        </p>

        {/* GDC & PDC */}
        <div className="cap-wrapper2">

          <div className="cap-card">

            <div className="cap-header">
              Gravity Die Casting (GDC)
            </div>

            <div className="cap-body">
              <ul>
                <li>
                  Automatic GDC lines for complex,
                  high-strength applications.
                </li>

                <li>
                  Excellent grain structure and reduced porosity for
                  critical parts.
                </li>

                <li>
                  Ideal for cylinder heads, brackets, housings, and
                  specialty components
                </li>

                <li>
                  Ideal for cylinder heads, brackets, housings and
                  specialty components in low-to-medium volumes.
                </li>
              </ul>
            </div>

          </div>

          <div className="cap-card">

            <div className="cap-header">
              High-Pressure Die Casting (HPDC)
            </div>

            <div className="cap-body">

              <ul>
                <li>
                  Automated ladling, spraying and extraction for stable,
                  repeatable cycles.
                </li>

                <li>
                  Digital monitoring of temperature, shot profiles and
                  cycle times.
                </li>

                <li>
                  Capable of structural, chassis, powertrain and EV
                  components with tight dimensional accuracy.
                </li>
              </ul>

              <p>
                Together, these processes enable us to support a wide
                spectrum of needs – from lightweight EV structures to
                high-strength commercial vehicle powertrain parts.
              </p>

            </div>

          </div>

        </div>

        {/* HEAT TREATMENT & MACHINING */}
        <div className="cap-wrapper2">

          {/* HEAT TREATMENT */}
          <div className="cap-card">

            <div className="cap-header">
              Heat Treatment for Strength & Durability
            </div>

            <div className="cap-body">

              <p>
                Our plants are equipped with advanced heat-treatment
                systems designed to meet demanding global OEM standards.
              </p>

              <ul>
                <li>
                  Automated furnaces for consistent, uniform temperature
                  control.
                </li>

                <li>
                  Capability for{" "}
                  <span
                    style={{
                      color: "#0052B4",
                      fontWeight: "bold",
                    }}
                  >
                    T5, T6, T7
                  </span>{" "}
                  and customer-specific cycles
                </li>

                <li>
                  Controlled quenching for optimal mechanical properties
                </li>

                <li>
                  Uniform hardness, improved ductility and enhanced
                  fatigue resistance.
                </li>
              </ul>

              <p>
                This ensures every component achieves the microstructural
                integrity required for harsh automotive environments.
              </p>

            </div>

          </div>

          {/* PRECISION MACHINING */}
          <div className="cap-card">

            <div className="cap-header">
              Precision Machining
            </div>

            <div className="cap-body">

              <p>
                SCL’s machining ecosystem combines{" "}
                <span
                  style={{
                    color: "#0052B4",
                    fontWeight: "bold",
                  }}
                >
                  high-speed CNC technology, lean layouts, and digital
                  integration
                </span>{" "}
                to deliver world-class precision.
              </p>

              <ul>
                <li>
                  Multi-axis CNC machining centers with multi-model
                  flexibility.
                </li>

                <li>
                  Robotic part handling and automated setups for high
                  utilisation.
                </li>

                <li>
                  In-line gauging, vision inspection and CMM validation.
                </li>

                <li>
                  Real-time SPC and adaptive process corrections for
                  stable capability.
                </li>
              </ul>

              <p>
                Whether finishing a structural EV component or a complex
                powertrain housing, our machining lines ensure{" "}
                <span
                  style={{
                    color: "#0052B4",
                    fontWeight: "bold",
                  }}
                >
                  repeatability, tight tolerances, and consistent surface
                  finish at scale.
                </span>
              </p>

            </div>

          </div>

        </div>

        {/* FOOTER */}
        <Footer />

      </section>
    </section>
  );
}